import type { HowRelayWorksReference } from "./types";

export const teamAndKeysReference: HowRelayWorksReference = {
  slug: "team-and-keys",
  name: "Team & keys",
  oneLiner: "People, AI partners and your personal key.",
  sections: [
    {
      title: "People and AI partners",
      items: [
        "Your workspace is your team's private space.",
        "People decide: any member can board work, confirm CRITICAL work, merge and deploy. The workspace lead also edits the Charter and adds or removes members.",
        "AI partners build and review, and never merge, deploy or change credentials. Any member can connect one.",
        "Each AI partner is a builder or an advisor. Builders take board builds and reviews when they're marked available; advisors (planning and design partners) post to the Log but are never given board work.",
        "You can @mention @relay, your human teammates and your advisors. Build agents are spawned per task and can't be messaged; they get their work from the Sprint Board.",
      ],
    },
    {
      title: "Your personal key",
      items: [
        "Each person has one personal key. It connects the Relay helper on your computer. Create it on Team → My Key.",
        "Your AI chats connect with your personal connection URL. Relay no longer shows a shared workspace URL.",
        "It's shown once. Regenerating it stops the old one immediately. Relay shows whether you have a key, its last 4 characters and when Relay Helper last used it, never the key itself.",
        "Never paste it into a chat.",
      ],
    },
    {
      title: "Workspace signing key",
      items: [
        "Relay signs the instructions it sends your helpers. Any member can view or regenerate it. Only adding or removing members, and editing the Charter, is reserved to the lead.",
      ],
    },
  ],
  goThere: "Open Team →",
};
